(function () {
  if (!document.querySelector("featured-collection-carousel")) return;
  const initSlider = () => {
    document
      .querySelectorAll(".js-recommendation-swiper")
      .forEach((elem, index) => {
        let mobileLayout = 1;
        if (elem.dataset.mobileLayout) {
          mobileLayout = elem.dataset.mobileLayout;
        }
        let slider = new Swiper(elem, {
          slidesPerView: mobileLayout,
          slidesPerGroup: 1,
          spaceBetween: 8,
          speed: 1000,
          navigation: {
            nextEl: elem.querySelector(
              ".product-recommendations__slider-nav .swiper-button-next",
            ),
            prevEl: elem.querySelector(
              ".product-recommendations__slider-nav .swiper-button-prev",
            ),
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            750: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            1200: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          },
        });
      });
  };

  const initSection = () => {
    document.querySelectorAll("featured-collection-carousel")
      .forEach(section => {
        const sectionResizeObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          let top = calcTop(section);
          if (section.querySelector(".product-recommendations__slider-nav"))
            section.querySelector(
              ".product-recommendations__slider-nav",
            ).style.top = top + "px";
        });
    
        sectionResizeObserver.observe(section);
    
        initSlider();
      });

  };

  function swiperInit() {
    initSlider();
    initSection();
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
  }

  document.addEventListener('shopify:section:load', function (e) {
    swiperInit();
  });

  swiperInit();
})();


const calcTop = (section) => {
  const imageWrapper = section.querySelectorAll(".card__inner");
  let top = 0;

  if (imageWrapper) {
    top = imageWrapper[0].offsetHeight / 2;
  } else {
    top = 50;
  }

  return top;
};